import { FormsAnswerFragment } from 'generated/resources/graphql'

import { elementFromData } from 'modules/forms/hooks/useForms'
import { Form } from 'modules/forms/lib/Form'
import { QuizBlock } from 'modules/trainings/lib/content/QuizBlock'

export const populateFormWithAnswers = (form: Form, answers: FormsAnswerFragment[]): Form => {
  answers.forEach((answer) => {
    const elementId = answer?.elementId || ''
    const element = form.getElement(elementId)

    if (element && answer) {
      element.answer = {
        answer: answer.answer || '',
        comment: answer.comment || undefined,
        options: answer.elementOptionIds || [],
        isCorrect: answer.isCorrect ?? undefined,
      }
    }
  })

  return form
}

export const extractFormFromQuizBlock = (quiz: QuizBlock): Form | undefined => {
  quiz.title = quiz.title || ''

  if (!quiz.form) {
    return undefined
  }

  const configuration = {
    allowedElements: quiz.form.configuration?.allowedElements || [],
    retryable: quiz.form.configuration?.retryable ?? true,
    scorable: quiz.form.configuration?.scorable ?? true,
  }

  const formInstance = new Form(
    quiz.form.id || '',
    quiz.form.title,
    quiz.form.description || null,
    quiz.form.resourceType,
    quiz.form.resourceId || null,
    'quiz',
    'draft',
    false,
    [],
    {},
    configuration
  )

  quiz.form.elements.forEach((elementData) => {
    const element = elementFromData({
      id: elementData.id || undefined,
      label: elementData.label,
      description: elementData.description || '',
      mandatory: elementData.mandatory,
      options:
        elementData.options?.map((opt) => ({
          id: opt.id || undefined,
          label: opt.label,
          value: opt.value,
          isCorrect: opt.isCorrect || false,
        })) || [],
      params: {},
      position: elementData.position,
      sectionId: undefined,
      type: elementData.type,
      hasCorrectAnswer: elementData.hasCorrectAnswer || false,
      answer: {
        isCorrect: elementData.answer?.isCorrect || false,
        comment: elementData.answer?.comment || undefined,
        answer: elementData.answer?.answer || '',
        options: elementData.answer?.options?.map((opt) => opt.id || '') || undefined,
      },
    })
    formInstance.addElement(element)
  })

  return formInstance
}
